import { IProjectMetadata } from '@/interfaces/report';
import {
  IAgencyCostActivityImperial,
  IAgencyCostImperial,
  IAgencyCostLineItemImperial,
} from '@/modules/agencyCost/interfaces/agencyCost';
import { UnitSystem } from '@/interfaces/units';
import { BaseScenarioType } from '@/lib/types/IBaseScenario';
import { getUserId } from '@/modules/design/lib/r23ToSuiteTransformers';

export const createNewAgencyCostScenario = function (project: IProjectMetadata | null): IAgencyCostImperial {
  const agencyScenario: IAgencyCostImperial = {
    id: null,
    user: getUserId(),
    project: project ? project.id : -1,
    scenarioType: BaseScenarioType.agencyCost,
    unitSystem: UnitSystem.Imperial,
    displayUnits: project ? project.displayUnits : UnitSystem.Imperial,
    isComputedFromLegacy: false,
    visible: true,

    name: 'New Agency Cost Scenario',
    created: new Date(Date.now()).toISOString(),
    modified: new Date(Date.now()).toISOString(),

    isDefault: false,

    district: null,
    county: null,
    route: null,

    fromLocation: null,
    toLocation: null,

    numTravelLanes: null,
    numDirections: null,

    startYear: 2020,
    discountRate_pct: 4,

    fromStation_ft: null,
    toStation_ft: null,

    totalLength_mi: 1,

    laneWidth_ft: 24,
    insideShoulderWidth_ft: 4,
    outsideShoulderWidth_ft: 12,
    jointSpacing_ft: 15,

    activities: [],
  };

  return agencyScenario;
};


export const createNewAgencyCostActivityImperial = function (scenario: IAgencyCostImperial):
  IAgencyCostActivityImperial {
  const newActivity: IAgencyCostActivityImperial = {
    id: null,
    name: 'New Activity',
    unitSystem: scenario.unitSystem,
    yearsAfterStart: scenario.activities.length ? scenario.activities.slice(-1)[0].yearsAfterStart + 1 : 0,
    lineItems: <IAgencyCostLineItemImperial[]>[],
  };

  return newActivity;
};
